import { useEffect, useRef } from "react";
import "ol/ol.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { fromLonLat } from "ol/proj";
import { Feature } from "ol";
import { Point } from "ol/geom";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Style, Icon } from "ol/style";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import LocationLogo from "../../assets/image/mark-location.png";

const Contact = () => {
  const mapRef = useRef(null);
  const coords = [76.8433, 30.657];

  useEffect(() => {
    if (!mapRef.current) return;

    const marker = new Feature({
      geometry: new Point(fromLonLat(coords)),
    });

    marker.setStyle(
      new Style({
        image: new Icon({
          anchor: [0.5, 1],
          src: LocationLogo,
          scale: 0.08,
        }),
      }),
    );

    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [marker],
      }),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        vectorLayer,
      ],
      view: new View({
        center: fromLonLat(coords),
        zoom: 16,
      }),
    });

    return () => map.setTarget(null);
  }, []);

  return (
    <section className="py-5 bg-light text-dark">
      <div className="container">
        <div className="row g-4 align-items-stretch shadow-sm rounded overflow-hidden p-4 bg-white">
          <div className="col-12 col-md-6 d-flex flex-column gap-4">
            <h2 className="fw-bold text-dark fs-5">Contact Us</h2>
            <p className="text-primary">
              We'd love to hear from you. Reach out anytime.
            </p>

            <div
              className="d-flex shadow-sm rounded bg-white border"
              style={{ padding: "16px", alignItems: "flex-start" }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                style={{
                  width: "48px",
                  height: "48px",
                  minWidth: "48px",
                }}
              >
                <FaMapMarkerAlt size={18} />
              </div>

              <div style={{ marginLeft: "12px" }}>
                <p className="fw-semibold mb-1">Our Office</p>
                <p className="small mb-0 text-muted">
                  SecureVenture Pvt. Ltd., 44L & 6L Lower Ground Floor,
                  <br />
                  Tricity Plaza, Peer Muchalla,
                  <br />
                  Zirakpur, Punjab 140603
                </p>
              </div>
            </div>

            <div
              className="d-flex shadow-sm rounded bg-white border"
              style={{ padding: "16px", alignItems: "flex-start" }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                style={{
                  width: "48px",
                  height: "48px",
                  minWidth: "48px",
                }}
              >
                <FaEnvelope size={18} />
              </div>

              <div style={{ marginLeft: "12px" }}>
                <p className="fw-semibold mb-1">Email</p>
                <a
                  href="mailto:sales@fieldsathi.com"
                  className="d-block text-dark small"
                >
                  sales@fieldsathi.com
                </a>
                <a
                  href="mailto:support@fieldsathi.com"
                  className="d-block text-dark small"
                >
                  support@fieldsathi.com
                </a>
              </div>
            </div>

            <div
              className="d-flex shadow-sm rounded bg-white border"
              style={{ padding: "16px", alignItems: "flex-start" }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                style={{
                  width: "48px",
                  height: "48px",
                  minWidth: "48px",
                }}
              >
                <FaPhoneAlt size={18} />
              </div>

              <div style={{ marginLeft: "12px" }}>
                <p className="fw-semibold mb-1">Phone</p>
                <a href="tel:7733976339" className="text-dark small">
                  +91 77339-76339
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div
              className="position-relative w-100 h-100 rounded shadow-sm border overflow-hidden"
              style={{ height: "450px" }}
            >
              <div
                ref={mapRef}
                className="position-absolute top-0 start-0 w-100 h-100"
              />
              <div
                className="position-absolute bg-white shadow rounded p-3"
                style={{
                  top: "20px",
                  left: "20px",
                  width: "270px",
                  zIndex: 10,
                }}
              >
                <span className="badge bg-success mb-2">Head Office</span>

                <h6 className="fw-bold mb-1">Zirakpur Office</h6>

                <p className="small text-muted mb-3">
                  Tricity Plaza, Peer Muchalla,
                  <br />
                  Zirakpur, Punjab
                </p>

                <a
                  href={`https://www.google.com/maps?q=${coords[1]},${coords[0]}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary w-100"
                >
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
